<template>
  <vx-card title="Accreditation Type">
    <div id="user-edit-tab-info">
      <div class="vx-row">
        <div class="vx-col w-full">
          <div class="vx-col w-full mb-base">
            <template>
              <vs-table
                stripe
                max-items="8"
                pagination
                search
                :data="getAccreditationType"
              >
                <template slot="thead">
                  <vs-th>Id</vs-th>
                  <vs-th>Code</vs-th>
                  <vs-th>Description</vs-th>
                  <vs-th>Action</vs-th>
                </template>

                <template slot-scope="{ data }">
                  <vs-tr
                    :data="tr"
                    :key="indextr"
                    v-for="(tr, indextr) in data"
                  >
                    <vs-td :data="data[indextr].accreditationTypeId">
                      {{ data[indextr].accreditationTypeId }}
                    </vs-td>
                    <vs-td :data="data[indextr].accreditationTypeCode">
                      {{ data[indextr].accreditationTypeCode }}
                    </vs-td>
                    <vs-td :data="data[indextr].accreditationTypeName">
                      {{ data[indextr].accreditationTypeName }}
                    </vs-td>
                    <vs-td>
                      <div :style="{ direction: $vs.rtl ? 'rtl' : 'ltr' }">
                        <feather-icon
                          icon="Edit3Icon"
                          svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer"
                          @click="editRecord(data[indextr].accreditationTypeId)"
                        />
                        <feather-icon
                          icon="Trash2Icon"
                          svgClasses="h-5 w-5 hover:text-danger cursor-pointer"
                          @click="
                            confirmDeleteRecord(
                              data[indextr].accreditationTypeId
                            )
                          "
                        />
                      </div>
                    </vs-td>
                  </vs-tr>
                </template>
              </vs-table>
            </template>
          </div>
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col w-full">
          <vs-button
            type="gradient"
            color="primary"
            @click="promptAddNewRecord()"
            icon-pack="feather"
            icon="icon-plus"
            >Add</vs-button
          >
        </div>
      </div>
      <!-- ADD ACCREDITATIONTYPE DATA -->
      <vs-prompt
        class="email-compose"
        title="Add Accreditation Type Data"
        accept-text="Submit"
        @accept="onAddNewRecord"
        :is-valid="validForm"
        :active.sync="activePromptAddRecord"
      >
        <vx-card title="Please fill-out the following information">
          <div class="vx-row mb-3">
            <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
              <span class="text-sm">Code</span>
              <span style="color: red">*</span>
              <vs-input
                name="code"
                v-validate="'required'"
                class="w-full"
                v-model="accreditationType.accreditationTypeCode"
              />
              <span class="text-danger text-sm" v-show="errors.has('code')">{{
                errors.first("code")
              }}</span>
            </div>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
              <span class="text-sm">Description</span
              ><span style="color: red">*</span>
              <vs-input
                name="name"
                v-validate="'required'"
                class="w-full"
                v-model="accreditationType.accreditationTypeName"
              />
              <span class="text-danger text-sm" v-show="errors.has('name')">{{
                errors.first("name")
              }}</span>
            </div>
          </div>
        </vx-card>
      </vs-prompt>
      <!-- END ACCREDITATIONTYPE DATA -->

      <!-- EDIT ACCREDITATIONTYPE DATA -->
      <vs-prompt
        class="email-compose"
        title="Edit Accreditation Type"
        accept-text="Submit"
        @accept="onUpdateRecord"
        :is-valid="validForm"
        :active.sync="activePromptEditRecord"
      >
        <vx-card title="You may update the following information">
          <div class="vx-row mb-3">
            <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
              <span class="text-sm">Code</span>
              <span style="color: red">*</span>
              <vs-input
                name="code"
                v-validate="'required'"
                class="w-full"
                v-model="accreditationType.accreditationTypeCode"
              />
              <span class="text-danger text-sm" v-show="errors.has('code')">{{
                errors.first("code")
              }}</span>
            </div>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
              <span class="text-sm">Description</span
              ><span style="color: red">*</span>
              <vs-input
                name="name"
                v-validate="'required'"
                class="w-full"
                v-model="accreditationType.accreditationTypeName"
              />
              <span class="text-danger text-sm" v-show="errors.has('name')">{{
                errors.first("name")
              }}</span>
            </div>
          </div>
        </vx-card>
      </vs-prompt>
      <!-- END EDIT ACCREDITATIONTYPE

 DATA  -->
    </div>
  </vx-card>
</template>
<script>
import Datepicker from "vuejs-datepicker";
import vSelect from "vue-select";

export default {
  data() {
    return {
      accreditationType: {
        accreditationTypeId: 0,
        accreditationTypeCode: "",
        accreditationTypeName: "",
      },
      activePromptAddRecord: false,
      activePromptEditRecord: false,
    };
  },
  created() {
    this.$store.dispatch("lookup/getAllAccreditationType").catch((err) => {
      console.log(err);
    });
  },
  components: {
    "v-select": vSelect,
  },
  computed: {
    getAccreditationType() {
      return this.$store.state.lookup.getAllAccreditationType;
    },
    validForm() {},
  },
  methods: {
    promptAddNewRecord() {
      this.activePromptAddRecord = true;
    },
    onAddNewRecord() {
      this.$vs.loading();
      this.$store
        .dispatch("lookup/addAccreditationType", this.accreditationType)
        .then((response) => {
          this.$vs.loading.close();
          if (response.status == 200)
            this.$alert("", "Save Successfully", "success");
        })
        .catch((error) => {
          this.$vs.loading.close();
          this.$alert(error, "Error", "error");
        });
    },
    editRecord(id) {
      const e = this.$store.getters["lookup/accreditationType"](id);

      (this.accreditationType.accreditationTypeId = id),
        (this.accreditationType.accreditationTypeCode =
          e.accreditationTypeCode),
        (this.accreditationType.accreditationTypeName =
          e.accreditationTypeName),
        (this.activePromptEditRecord = true);
    },
    onUpdateRecord() {
      this.$vs.loading();
      this.$store
        .dispatch("lookup/updateAccreditationType", this.accreditationType)
        .then((response) => {
          this.$vs.loading.close();
          if (response.status == 200)
            this.$alert("", "Updated Successfully", "success");
        })
        .catch((error) => {
          this.$vs.loading.close();
          this.$alert(error, "Error", "error");
        });
    },
  },
};
</script>
